module.exports = __webpack_public_path__ + "img/Weapon_249.8e972544.png";